import { render, staticRenderFns } from "./AudioFileInfo.vue?vue&type=template&id=60aab72c&"
import script from "./AudioFileInfo.vue?vue&type=script&lang=js&"
export * from "./AudioFileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports